import React from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";

import picas from "../../assets/img/picas.PNG";
import cloth from "../../assets/img/cloth.PNG";
import college from "../../assets/img/college.PNG";
import talkia from "../../assets/img/talkia.PNG";
import classes from "./Projects.module.scss";

function Projects() {
  return (
    <section id="projects" className={classes.projects}>
      <div className="container py-5 my-5">
        <h3 className="text-color-heading section-heading animate__animated  heading-2">
          PROJECTS
        </h3>
        <div className="">
          <Tabs selectedTabClassName={classes.active}>
            <TabList className={classes.tabs}>
              <Tab>
                <h4>ALL</h4>
              </Tab>
              <Tab>
                <h4>JAVASCRIPT</h4>
              </Tab>
              <Tab>
                <h4>REACTJS</h4>
              </Tab>
            </TabList>

            <TabPanel>
              <div className="row " style={{margin:'7rem 0'}}>
                <div className="col-md-3">
                  <a href="https://picas.netlify.app/" target="_blank">
                    <img src={picas} className="img-fluid" alt="" />
                  </a>
                </div>
                <div className="col-md-3">
                  <a href="https://gndit.netlify.app/" target="_blank">
                    <img src={college} className="img-fluid" alt="" />
                  </a>
                </div>
                <div className="col-md-3">
                  <a href="https://clothfire.netlify.app/" target="_blank">
                    <img src={cloth} className="img-fluid" alt="" />
                  </a>
                </div>
                <div className="col-md-3">
                  <a href="https://talkia.netlify.app/" target="_blank">
                    <img src={talkia} className="img-fluid" alt="" />
                  </a>
                </div>
              </div>
            </TabPanel>
            <TabPanel>
              <div className="row "  style={{margin:'7rem 0'}}>
              <div className="col-md-3">
                  <a href="https://gndit.netlify.app/" target="_blank">
                    <img src={college} className="img-fluid" alt="" />
                  </a>
                </div>
              </div>
            </TabPanel>
            <TabPanel>
              <div className="row"  style={{margin:'7rem 0'}}>
                  <div className="col-md-3">
                  <a href="https://talkia.netlify.app/" target="_blank">
                    <img src={talkia} className="img-fluid" alt="" />
                  </a>
                </div>

                  <div className="col-md-3">
                  <a href="https://clothfire.netlify.app/" target="_blank">
                    <img src={cloth} className="img-fluid" alt="" />
                  </a>
                </div>

                 <div className="col-md-3">
                  <a href="https://picas.netlify.app/" target="_blank">
                    <img src={picas} className="img-fluid" alt="" />
                  </a>
                </div>

              </div>
            </TabPanel>
          </Tabs>
        </div>
      </div>
    </section>

    // <div>
    //   <Tabs>
    //     <TabList>
    //       <Tab>Title 1</Tab>
    //       <Tab>Title 2</Tab>
    //     </TabList>

    //     <TabPanel>
    //       <h2>Any content 1</h2>
    //     </TabPanel>
    //     <TabPanel>
    //       <h2>Any content 2</h2>
    //     </TabPanel>
    //   </Tabs>
    // </div>
  );
}

export default Projects;
